import { Fragment, useState, useEffect } from 'react'

import { useRouter } from 'next/router'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'

import MerchMenuPage from 'components/Menu/MerchMenuPage'

export interface MerchMenuModalProps<T> {
  setOpenShareModal: any
  editStoreSettings: any
  newProductURL: any
  isCreatedMerch: boolean
  open: boolean
  onClose: () => void
}

const MerchMenuModal = <T,>({
  open,
  onClose,
  setOpenShareModal,
  editStoreSettings,
  isCreatedMerch,
  newProductURL,
}: MerchMenuModalProps<T>) => {
  const router = useRouter()

  const closeModal = () => {
    onClose()
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>
        <div className="fixed inset-0" onClick={() => closeModal()}>
          <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
            <div className="w-full h-full">
              <MerchMenuPage
                isOwn={isCreatedMerch}
                setOpenShareModal={setOpenShareModal}
                editStoreSettings={editStoreSettings}
                addMerchItem={() => {
                  router.push(newProductURL)
                }}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default MerchMenuModal
